import { Component, Input } from '@angular/core';
const imageUrl = '../../../images/no-invoices-icon.svg';

@Component({
  selector: 'send-invoices-indicator',
  template: `
    <p class="margin-bottom--4px" *ngIf="!sendInvoices">
      <img src="${imageUrl}" />
      <span>Faktureras ej</span><span class="padding-left--1x text--italic" *ngIf="message">{{ message }}</span>
    </p>
  `,
  styles: ['img { max-width: 16px; transform: translateY(-2px);}'],
  standalone: false,
})
export class SendInvoicesIndicator {
  @Input() sendInvoices = true;
  @Input() message: string;
}
